'use client';
import Image from 'next/image';
import { getImageVariants } from '@/lib/news_helpers';
import React, { useRef, useState, useLayoutEffect } from 'react';

interface AvatarLocationProps {
  imageUrl?: string;
  label: string;
}
const AvatarLocation = ({ imageUrl, label }: AvatarLocationProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [fontSize, setFontSize] = useState('text-xl');

  const getInitials = (label: string) => {
    const words = label.trim().split(' ');
    if (words.length === 1) {
      return words[0].slice(0, 2).toUpperCase();
    }
    return words[0][0].toUpperCase() + words[1][0].toUpperCase();
  };

  useLayoutEffect(() => {
    if (containerRef.current) {
      const width = containerRef.current.offsetWidth;
      if (width < 40) setFontSize('text-xs');
      else if (width < 64) setFontSize('text-sm');
      else if (width < 96) setFontSize('text-lg');
      else if (width < 128) setFontSize('text-xl');
      else setFontSize('text-3xl');
    }
  }, []);

  return (
    <div
      ref={containerRef}
      className='relative flex items-center justify-center rounded-lg bg-gray-200 text-gray-700 font-semibold w-full h-full overflow-hidden'
    >
      {imageUrl ? (
        <Image
          src={getImageVariants(imageUrl, 'm')[0]}
          alt={label}
          fill
          className='rounded-lg object-cover'
          loading='lazy'
          sizes='(max-width: 240px) 100vw, 15vw'
        />
      ) : (
        <span
          className={`w-full h-full flex items-center justify-center ${fontSize}`}
        >
          {getInitials(label)}
        </span>
      )}
    </div>
  );
};

export default AvatarLocation;
